import * as React from "react";

import { formatDate, formatCurrency } from "app/utils/filters";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";

import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

export type GqlRefundRequest = {
  id: bigint;
  amount: number;
  comments: string;
  created_at: string;
  original_payment_id: string;
  status: string;
  updated_at: string;
  original_payment: {
    reference: string;
  };
  refund_payment: {
    reference: string;
  };
};

export const columnConfigFactory = (): Array<ColumnConfig> => [
  {
    name: "Date created",
    render: (refund: GqlRefundRequest) => formatDate(refund?.created_at),
  },
  {
    name: "Original payment",
    render: (refund: GqlRefundRequest) => (
      <BackOfficeLink
        backofficeUrl={`/snapscan/ops/payments/${refund?.original_payment?.reference}/summary`}
      >
        {refund?.original_payment?.reference}
      </BackOfficeLink>
    ),
  },
  {
    name: "Refund payment",
    render: (refund: GqlRefundRequest) => (
      <BackOfficeLink
        backofficeUrl={`/snapscan/ops/payments/${refund?.refund_payment?.reference}/summary`}
      >
        {refund?.refund_payment?.reference ?? "-"}
      </BackOfficeLink>
    ),
  },
  {
    name: "Status",
    render: (refund: GqlRefundRequest) => refund?.status,
  },
  {
    name: "Amount",
    cellProps: { align: "right" },
    render: (refund: GqlRefundRequest) => `R${formatCurrency(refund?.amount)}`,
  },
  {
    name: "Comments",
    render: (refund: GqlRefundRequest) => refund?.comments,
  },
];

export default columnConfigFactory;
